import styled, { css } from 'styled-components';
import { Colors, Media, TextStylesDesktop, TextStylesMobile } from 'enums';
import { CSS_FOR_SCROLL_WITH_PADDING } from 'styles/customScrollWithPadding';

export const ModalStyles = css`
  flex-direction: column;
  gap: 24px;
  max-height: calc(100% - 64px);

  @media ${Media.notebook} {
    gap: 32px;
  }
`;

export const Title = styled.div`
  text-align: center;
`;

export const CommentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  overflow-y: auto;

  ${CSS_FOR_SCROLL_WITH_PADDING}
`;

export const CommentCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  background-color: ${Colors.gray5};

  @media ${Media.notebook} {
    gap: 16px;
    padding: 16px;
  }
`;

export const CommentText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  word-break: break-word;

  ${TextStylesMobile.body}

  @media ${Media.notebook} {
    ${TextStylesDesktop.body}
  }
`;

export const CommentLabel = styled.span`
  font-weight: 600;
`;

export const CommentDateTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  color: ${Colors.gray2};

  ${TextStylesMobile.small1}

  @media ${Media.notebook} {
    ${TextStylesDesktop.small1}
  }
`;
